import { LitElement, html, css } from 'lit'

class ComponentCanvas extends LitElement {
  static get properties() {
    return {
      content: { type: String },
      device: { type: String },
      iframeStyle: { type: String },
    }
  }
  static styles = css`
    :host {
      width: 100%;
      height: 100%;
      display: block;
    }

    iframe {
      display: flex;
      width: 100%;
      height: 100%;
      border: none;
      overflow: hidden;
    }
    .iframe-container {
      width: 100%;
      height: 100%;
    }
    .iframe-container.mobile {
      position: relative;
      display: flex;
      width: 400px;
      height: 800px;
      margin: auto;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    }
  `

  constructor() {
    super()

    this.iframe = ''
    this.device = 'desktop'

    window.addEventListener(
      'message',
      (e) => {
        let message = e.data
        if (!message.height) return

        this.iframeStyle = `
        height: ${message.height}px;
        `
      },
      false
    )
  }

  firstUpdated() {
    this.content = this.innerHTML

    this.iframe = `<!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <title>{{ title }}</title>
        <link rel="stylesheet" href="https://use.typekit.net/tlp6chl.css" />
        <link rel="stylesheet" href="/bundle/almi.css" />
        <link rel="stylesheet" href="/_styleguide/styles/styleguide.css" />
        <style>
          body {
            padding: 32px 0;
          }
        </style>
      </head>
      <body>
      ${this.content}
      <script>
        var ro = new ResizeObserver( entries => {
          for (let entry of entries) {
            const height = entry.borderBoxSize[0].blockSize;
            window.parent.postMessage(
              { height },
              '*'
            );
          }
        });
        ro.observe(document.querySelector('body'));
      </script>
      <script src="/bundle/almi.js"></script>
      </body>
    </html>`
  }

  render() {
    return html`<div class="iframe-container ${this.device}">
      <iframe style="${this.iframeStyle}" srcdoc="${this.iframe}"></iframe>
    </div>`
  }
}

customElements.define('component-canvas', ComponentCanvas)
